export function TermsPage() {
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold">Terms of Use</h1>
        <p className="text-sm text-ink-muted mt-1">Service terms for AI Security & Compliance Hub.</p>
      </div>

      <div className="card space-y-3 text-sm leading-6 text-ink-muted">
        <p>
          By using this service, customer agrees to comply with applicable laws, maintain secure account practices,
          and use the platform only for authorized governance and compliance activities.
        </p>
        <p>
          Subscription billing, plan upgrades, and lifecycle actions are governed by Azure Marketplace terms
          and applicable private offer agreements.
        </p>
        <p>
          Full legal text will be finalized with legal entity details prior to go-live submission.
        </p>
      </div>
    </div>
  );
}
